/**
 * Translate all properties from a specified object
 * @param {import("../logic/types").EcrionFormState} state
 * @param {import("../logic/types").EcrionFormField} field
 * @returns {any} An object with all translated properties
 */
var translate = function translate(state, object) {
  if (!object) return {};
  var languages = state.languages,
      renderOptions = state.renderOptions;
  if (!renderOptions || !languages) return {};
  var languageId = renderOptions.languageId;
  if (!languages[languageId]) return {};
  var translations = languages[languageId].translations;
  if (!translations) return {};
  var map = translations[object.id];
  if (!map) return {};
  var result = {};
  Object.keys(object).forEach(function (propertyName) {
    if (map[propertyName]) result[propertyName] = map[propertyName];
  });
  return result;
};

export default {
  translate: translate
};